import { Injectable } from '@angular/core';
import { InputAccessoriesService } from 'src/app/services/input-accessories/input-accessories.service';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Injectable({
	providedIn: 'root',
})
export class PadControlLinkFeature {
	constructor(
		private keyboardService: InputAccessoriesService,
		private loggerService: LoggerService
	) {}

	public async getCapabililty() {
		const isMouseCapabable = this.keyboardService.getMouseCapability();
		const isTouchPadCapable = this.keyboardService.getTouchPadCapability();

		const isPadControlCapable = await Promise.all([isMouseCapabable, isTouchPadCapable])
			.then((padControlCapabilities) => {
				const [mouseCapability, touchPadCapability] = padControlCapabilities;
				const isCapable = mouseCapability || touchPadCapability;
				this.loggerService.info('padControlLinkFeature Capability: ', isCapable);

				return isCapable;
			})
			.catch((error) => {
				this.loggerService.error('padControleLinksFeature error: ', error.message);

				return false;
			});

		return isPadControlCapable;
	}
}
